import type { RoadmapSummaryCreatorBasicInfo } from './roadmapSummaryCreatorBasicInfo';
import type { RoadmapSummaryCreatorSocial } from './roadmapSummaryCreatorSocial';

/**
 * 로드맵 생성자 정보
 */
export type RoadmapSummaryCreator = {
  /** 사용자 기본 정보 */
  basicInfo: RoadmapSummaryCreatorBasicInfo;
  /** 소셜 관계 정보 */
  social?: RoadmapSummaryCreatorSocial;
};
